import { Pressable, View } from "react-native";
type ToggleProps = Readonly<{
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}>;

export default function Toggle({
  value,
  onChange,
  disabled = false,
}: ToggleProps) {
  return (
    <Pressable
      onPress={() => !disabled && onChange(!value)}
      className={`w-10 h-5 p-0.5 rounded-full border hover:opacity-90 ${
        value ? "bg-primary border-primary" : "bg-slate border-slate"
      } justify-center ${disabled ? "opacity-50" : ""}`}
    >
      <View
        className={`w-4 h-4 rounded-full bg-white shadow-sm elevation-2 ${
          value ? "self-end" : "self-start"
        }`}
      />
    </Pressable>
  );
}
